import React, { useEffect } from 'react'
import { useLedgerModel } from '../ledgerModel'
import { ISearchValue, SearchTypeEnum } from '@/components/YhPageHeader/Types'
import { YhPageHeader } from '@/components/YhPageHeader'
import useGlobalModel from '@/model/globalModel'

export function PageHeader() {
    const { searchParam, updateSearchParam, resetSearchParam, loadData, companyData, fetchCompanyList } = useLedgerModel()
    const {
        authData,
        user: { userType },
    } = useGlobalModel(({ user }) => [user])

    useEffect(() => {
        fetchCompanyList()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const searchFields: any = [
        {
            type: SearchTypeEnum.Input,
            placeholder: '司机/押运员/车牌号',
            fieldName: 'retrieveName',
            span: 6,
        },
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: '',
            rangePickerFieldName: ['startTime', 'endTime'],
            // placeholder: ["申请起始日期", "申请结束日期"],
            format: 'YYYY-MM-DD',
            alloc: true,
            span: 7,
        },
        ...((str) => {
            if (str) {
                return [
                    {
                        type: SearchTypeEnum.Select,
                        placeholder: '选择管理员',
                        fieldName: 'createUser',
                        mode: 'multiple',
                        options: authData.filter((item) => item.type === '管理员'),
                    },
                ]
            } else {
                return []
            }
        })(userType === '超级管理员'),
        {
            type: SearchTypeEnum.Select,
            placeholder: '产权公司',
            fieldName: 'company',
            options: companyData,
        },
        {
            type: SearchTypeEnum.CheckBox,
            placeholder: '不通过项',
            fieldName: 'threeInspectionStatus',
            span: 3,
        },
    ]

    return (
        <YhPageHeader
            title=""
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
            style={{ height: 'auto' }}
        />
    )
}
